import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'

export const parseCategoryAddonsBeforeSubmit = (categoryAddons?: TwinDictionary[]) => {
    const myCategoryAddons: TwinDictionary[] = []
    if (categoryAddons) {
        let order = 1
        for (const categoryAddon of categoryAddons) {
            const { ProductAddonId, CategoryId, ScaleByProductId, ScaleByVariableId, scaleQuantity, createDefault, multiplyByWeight, isParent } = categoryAddon
            myCategoryAddons.push({
                ProductAddonId,
                CategoryId,
                ScaleByProductId: ScaleByProductId || null,
                ScaleByVariableId: ScaleByVariableId || null,
                scaleQuantity: parseFloat(scaleQuantity),
                createDefault,
                multiplyByWeight,
                order,
                isParent
            })
            order++
        }
    }
    return myCategoryAddons
}

export const filterIfAlreadyExists = (actualIds: number[], existingIds: number[], data: TwinDictionary[]) => {
    const posIds: number[] = []
    const idsToAdd: number[] = []
    for (const key in existingIds) {
        const id= existingIds[key]
        if(!actualIds.includes(id)){
            posIds.push(parseInt(key))
            idsToAdd.push(id)
        }
    }
    const filteredData: TwinDictionary[] = []
    for (const pos of posIds) {
        filteredData.push(data[pos])
    }
    return { filteredData, idsToAdd}
}